var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 41,
    viewBox: "0 0 52 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6577 0H4.34236C1.94097 0 0 1.96763 0 4.39285V36.6072C0 39.0323 1.94097 41 4.34236 41H47.6577C50.059 41 52 39.0323 52 36.6072V4.39285C52 1.96763 50.059 0 47.6577 0ZM4.88403 4.39285H47.116C47.4139 4.39285 47.6577 4.63995 47.6577 4.94197V8.78573H4.34236V4.94197C4.34236 4.63995 4.58611 4.39285 4.88403 4.39285ZM47.116 36.6072H4.88403C4.58611 36.6072 4.34236 36.36 4.34236 36.058V20.5H47.6577V36.058C47.6577 36.36 47.4139 36.6072 47.116 36.6072ZM17.3333 27.4553V31.116C17.3333 31.7201 16.8458 32.2143 16.25 32.2143H9.75C9.15419 32.2143 8.66669 31.7201 8.66669 31.116V27.4553C8.66669 26.8513 9.15419 26.3572 9.75 26.3572H16.25C16.8458 26.3572 17.3333 26.8513 17.3333 27.4553ZM34.6667 27.4553V31.116C34.6667 31.7201 34.1792 32.2143 33.5833 32.2143H21.3055C20.7097 32.2143 20.2222 31.7201 20.2222 31.116V27.4553C20.2222 26.8513 20.7097 26.3572 21.3055 26.3572H33.5833C34.1792 26.3572 34.6667 26.8513 34.6667 27.4553Z",
    fill: "#828284"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCard);
export default __webpack_public_path__ + "static/media/bank_card.de707eb81e2d7336c0ab01b41387c5af.svg";
export { ForwardRef as ReactComponent };